<template>
    <div class="auth-wrapper auth-v2">
        <b-row class="auth-inner m-0">

            <!-- Brand logo-->
            <b-link class="brand-logo">
                <vuexy-logo />
                <h2 class="brand-text text-primary ml-1">TMS</h2>
            </b-link>
            <!-- /Brand logo-->

            <!-- Left Text-->
            <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
                <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                    <b-img fluid class="login-img" :src="sideImg" alt="Login V2"/>
                </div>
            </b-col>
            <!-- /Left Text-->

            <!-- Login-->
            <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
                <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
                    <b-card-title title-tag="h2" class="font-weight-bold mb-1">
                        Yeni Şifre Oluştur 🔑
                    </b-card-title>
                    <b-card-text class="mb-2">
                        Şifrenizi yeniden oluşturmak için e-posta giriniz.
                    </b-card-text>

                <!-- form -->
                
                    <b-form class="auth-login-form mt-2" @submit.prevent>
                        <!-- email -->
                        <b-form-group label="Yeni Şifre" label-for="recover-password">
                            <b-input-group class="input-group-merge">
                                <b-form-input :state="isNotEqual ? false : null" v-on:blur="controlSame" id="recover-password"  v-model="password" class="form-control-merge" :type="passwordFieldType" :name="`recover-password-${Date.now().toString()}`" placeholder="············"/>
                                <b-input-group-append is-text>
                                    <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility"/>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group label="Yeni Şifre Tekrarı" label-for="recover-password-repeat">
                            <b-input-group class="input-group-merge">
                                <b-form-input :state="isNotEqual ? false : null" v-on:blur="controlSame" id="recover-password-repeat" v-model="passwordRepeat" class="form-control-merge" :type="passwordFieldType" :name="`recover-password-again-${Date.now().toString()}`" placeholder="············"/>
                                <b-input-group-append is-text>
                                    <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility"/>
                                </b-input-group-append>
                            </b-input-group>
                            
                        </b-form-group>

                        <small v-if="isNotEqual" class="d-block text-danger mb-1">Şifreler eşleşmemektedir. Lütfen kontrol ediniz.</small>
                        
                        <b-button :disabled="!ready || loading" type="submit" variant="primary" class="d-flex align-items-center justify-content-center" block v-on:click="submit">
                            <b-spinner small class="mr-50" v-if="loading"></b-spinner>
                            Kaydet 
                        </b-button>
                    </b-form>
                </b-col>
            </b-col>
        <!-- /Login-->
        </b-row>
    </div>
</template>

<script>
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner} from 'bootstrap-vue'
import AuthApi from '@/api/auth'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
    components: {
        BRow,
        BCol,
        BLink,
        BFormGroup,
        BFormInput,
        BInputGroupAppend,
        BInputGroup,
        BFormCheckbox,
        BCardText,
        BCardTitle,
        BImg,
        BForm,
        BButton,
        BSpinner,
        VuexyLogo,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            status: '',
            password: '',
            isNotEqual:false,
            passwordRepeat: '',
            sideImg: require('@/assets/images/pages/forgot-password.svg'),
            loading:false,
        }
    },
    computed:{
        ready(){
            return this.password && this.passwordRepeat && this.password?.trim() && this.passwordRepeat?.trim() && this.password == this.passwordRepeat
        },
        passwordToggleIcon() {
			return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
		},
    },
    mounted(){
        this.email = null
    },
    methods: {
        submit() {  
            this.loading = true
            if(this.password){
                AuthApi.RecoveryPassword({
                    Email: this.$route.params?.email || null,
                    ForgotPasswordKey: this.$route.params?.key || null,
                    NewPassword: this.password
                }).then(res=>{
                    this.loading = false
                    this.$result(res)
                    if(res.data.Success){
                        this.$router.push({name:"login"})
                    }
                }).catch(err=>{
                    this.loading = false
                    this$result(null,err)
                })
            }   
        },
        controlSame(){
            if(this.password && this.passwordRepeat){
                if(this.password == this.passwordRepeat) this.isNotEqual = false
                else this.isNotEqual = true
            }else {
                this.isNotEqual = false
            }
        }
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
